
import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

import styles from './ConnectPop.module.css';
import pageStylePops from './pageStylePops.module.css';
import SwiperSection from '../ForAllComponents/SwiperSection';
import ConnUrls from '../Connections/ConnectURL';
import {
    theMenuItems
} from '../FAKEDB/fakes'
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import utilsSpecialPages from '../Connections/_Utils/utilsSpecialPages';
import MyFunctions from '../Functions/MyFunctions';
import PopUpClearComp from './PopUpClearComp';
import ConnectCodeCheck from './ConnectCodeCheck';
import utilsCodes from '../Connections/_Utils/utilsCodes';

const ConnectPop = (props) => {

    const navigate = useNavigate();
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);
    const [pageDetails, setPageDetails] = useState();
    const [phoneNum, setPhoneNum] = useState();
    const [erMsg, setErMsg] = useState("");
    const [thePopUp, setThePopUp] = useState();

    useEffect(() => {
    }, [mobiOrNot]);

    useEffect(() => {

        document.getElementById(`phoneInp`).focus();
    }, [])

    useEffect(() => {
        const getPageDetalis = async () => {
            let pg = await utilsSpecialPages.getStaticPageByName("LogOrRegPage")
            setPageDetails(pg);
        }
        getPageDetalis();
    }, [])


    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            setPhoneNum(phoneNum); setErMsg("");
            sendRequest();

        }
    };


    const sendRequest = async () => {
        let validatoring = "";
        setErMsg("")
        validatoring += MyFunctions.validPhone(phoneNum);

        if (validatoring == "") {
            let codeReply = await utilsCodes.createCodeSms(phoneNum);
            if (!codeReply.errormsg) {
                setThePopUp(
                    <PopUpClearComp BtnTxt={"סגור"}
                        title={"התחברות"}
                        btnFStyle={"fatInBtn"}
                        closePop={() => setThePopUp()}
                        parentCLose={() => props.parentCLose()}
                        theInsideComp={
                            <ConnectCodeCheck
                                codeReply={codeReply}
                                phoneNum={phoneNum}
                                backFunc={true}
                                closeMeFuc={() => setThePopUp()}
                                parentCLose={() => props.parentCLose()}
                                shoTopStrp={(tf) => { }}
                                scrollToTop={(stUp) => { }}
                                connectWithNumber={() => { setThePopUp(); }}
                            />
                        } />)
            }
            else {
                setErMsg(codeReply.errormsg)
            }
        }
        else {
            setErMsg(validatoring)
        }
    }

    return (
        <>
            <div className={`${pageStylePops.topPlace} regularPoint`}>
                <p className={`${pageStylePops.headBig} fullRow`}>התחברות באמצעות קוד</p>
                <span className={`${pageStylePops.secondHead} inColorgoldLine`}>יש להזין מספר טלפון נייד על מנת</span>
                <br />
                <span className={`${pageStylePops.secondHead} inColorgoldLine`}>לקבל קוד התחברות</span>
            </div>

            <div className={`${pageStylePops.mainWrap}`}>
                <div className={pageStylePops.contWrap}>
                    {/* <label className={`${pageStylePops.headInput}`}>מייל</label> */}
                    <input id={"phoneInp"} className={`${currnetStyle.inputPhone}`}
                        placeHolder={"הקלד מספר נייד"}
                        value={phoneNum}
                        onChange={(e) => { setPhoneNum(e.target.value); setErMsg(""); }}
                        onKeyDown={(e) => handleKeyDown(e)}
                        label="נייד" variant="filled" type="number" />
                </div>
                {/* <div className={pageStylePops.contWrap}>
                    <div className={"noDecoration"}>שלח לי שוב</div>
                </div> */}
                <div className={pageStylePops.contWrap}>
                    <div className={pageStylePops.btnGo}>
                        <button className={`${pageStylePops.contactGo} pointing`} value="שלח" onClick={() => sendRequest()} >שלח</button>
                    </div>
                    <div className={"fullRow errorLine"}>
                        <p>{parse(erMsg)}</p>
                    </div>

                </div>
                <div className={pageStylePops.contWrap}>
                    <div className={"noDecoration pointing linkMe"}>שלח לי למייל</div>
                </div>
            </div>
            {thePopUp}
        </>

    );
}

export default ConnectPop;
